import { HttpErrorResponse } from '@angular/common/http';

/**
 * Reads the machine-readable `errorCode` the API attaches to an error response.
 *
 * `GlobalExceptionFilter` spreads the exception response object into the body, so a
 * `BadRequestException({ message, errorCode })` arrives as `{ message, errorCode, statusCode, ... }`.
 * Returns `null` for errors thrown without one, so callers can fall back to rendering the message.
 */
export const resolveHttpErrorCode = (error: HttpErrorResponse): string | null => {
  return error?.error?.errorCode ?? null;
};
